// Mutable, non-reactive camera facts shared between the camera rig (writer) and
// the gesture handler (reader). Kept outside React/zustand because it changes
// every frame and nothing needs to re-render when it does.
export const view = {
  maxPan: 0, // world units the camera may slide left/right of the zone centre
  unitsPerPx: 0.02, // world units covered by one CSS pixel at the focal plane
};
